export default "__VITE_ASSET__DdNNRQJ$__"